import { SetStateAction, useMemo, useState } from "react";
import DataTable, { TableColumn } from "react-data-table-component";
import BoxComponent from "../../components/CommonComponents/BoxComponent/BoxComponent";
import { useDebounce } from "../../hooks/common";
import SortIcon from "../../components/CommonComponents/SortIcon/SortIcon";
import { tableCustomStyles } from "../../components/CommonComponents/Table/Table";
import { useBlockedPlotsViewer } from "../../hooks/blockedPlotViewer.hooks";
import PageHeader from "../../components/pageHeader/pageHeader";


type TBlockedPlot = {
    id: number;
    mauja: string;
    khasaraNo: string;
    plotNo: string;
    status: boolean;
};

export default function BlockedPlotsViewer() {
    const limit = 100; // small dataset
    const [page] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const search = useDebounce(searchQuery);

    const { data, isLoading } = useBlockedPlotsViewer(search);

    const filteredData = useMemo(() => {
        return (data || []) as TBlockedPlot[];
    }, [data]);

    const columns = useMemo(
        (): TableColumn<TBlockedPlot>[] => [
            {
                name: "Sr No",
                selector: (_, i = 0) => String(i + 1).padStart(3, "0"), center: true,
            },
            {
                name: "Mauja",
                selector: (d) => d.mauja,
                center: true,
            },
            {
                name: "Khasara Number",
                selector: (d) => d.khasaraNo,
                center: true,
            },
            {
                name: "Plot Number",
                selector: (d) => d.plotNo,
                center: true,
            },
        ],
        []
    );

    return (
        <div className="p-4 md:p-8 overflow-auto">
            <PageHeader
                title="Blocked Plots"
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                showSearchButton
                showAdditionalButton={false}
                showGridButton={false}
                showFilterButton={false}
                buttonTitle={""}
            />
            <BoxComponent>
                <DataTable
                    className="mt-4 rounded-0"
                    columns={columns}
                    data={filteredData}
                    progressPending={isLoading}
                    customStyles={tableCustomStyles}
                    sortIcon={<SortIcon />}
                />
            </BoxComponent>

            <div className="flex justify-center mt-6">
                <button
                    onClick={() => window.close()}
                    className="bg-black ml-4 px-8 py-2 font-bold text-white rounded-full"
                >
                    Close
                </button>
            </div>
        </div>
    );
}